import { AppointmentChannelSchema } from 'models/appointment-channel.model';
import { AppointmentStatusSchema } from 'models/appointment-status.models';
import { z } from 'zod';

const UserSchema = z.object({
  id: z.number().optional(),
  hash: z.string(),
  name: z.string(),
  avatar: z.string(),
  is_dismissed: z.boolean(),
  speciality: z.string().optional(),
  collegiate_number: z.string().optional(),
});

const OrganizationSchema = z.object({
  id: z.string(),
  api_key: z.string(),
  name: z.string(),
  logo: z.string(),
});

const PermissionsSchema = z.object({
  phone_calls: z.object({
    available: z.boolean(),
    enabled: z.boolean(),
  }),
  consultations: z.object({
    derivations: z.object({
      id: z.string().nullable(),
      required: z.boolean(),
    }),
    report: z.object({
      required: z.boolean(),
    }),
  }),
});

const BillingSchema = z.object({
  enabled: z.boolean(),
  provider: z.string(),
  image: z.string(),
});

export const AppointmentSchema = z.object({
  id: z.string(),
  room_id: z.number(),
  type: z.string(),
  service_type: z.string(),
  channel: AppointmentChannelSchema,
  duration: z.number(),
  timezone: z.string(),
  status: AppointmentStatusSchema,
  start_date: z.string(),
  started_at: z.string().nullable(),
  seconds_to_open: z.number(),
  expires_at: z.string(),
  retried_until: z.string().nullable(),
  price: z.number(),
  fee: z.number(),
  tpv_fee: z.number(),
  to: UserSchema,
  from: UserSchema,
  organization: OrganizationSchema,
  currency: z.string(),
  created_at: z.string(),
  provider: z.string(),
  payment_provider: z.string(),
  external_provider_id: z.string().nullable(),
  call_id: z.string(),
  no_show: z.boolean(),
  permissions: PermissionsSchema,
  is_immediate_video_call: z.boolean(),
  immediate_video_call_expires_at: z.string().nullable(),
  is_recordable: z.boolean(),
  billing: BillingSchema,
  appointment_confirmation_text: z.string().nullable(),
  consultation_short_url: z.string(),
});

export type Appointment = z.infer<typeof AppointmentSchema>;
